 /* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Mixins, Watch} from 'vue-property-decorator'
import {
    setMarketClue,
    duplicateCheck,
    getMarketClueById,
    setMarketClueById,
    getMarketChannelType,
    getMarketChannelNameByTypeId,
    getMarketCooperationPrevLevel, getMarketHighSchoolBranchCenterList, getSchoolList, setSchool
} from '@/api/common'
import data from './data'
import {UserModule} from '@/store/modules/user'
 import {delNullProperty} from "@/utils";

@Component({})
export default class NewClue extends Mixins(data) {
    // ------ 变量 ------
    sourceId = ''
    sourceList = [
        {name: '合作伙伴', val: '0'},
        {name: '市场渠道', val: '1'},
        {name: '其它', val: '2'},
        {name: '高校', val: '3'},
        {name: '分管', val: '4'},
    ]
    cooperativePartnerList: { name: string; id: number }[] = [] // 合作伙伴列表
    collegesList: { name: string; id: number }[] = [] // 高校列表
    branchedPassageList: { name: string; id: number }[] = [] // 分管列表
    gradeList = [  // 年级列表
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业',
        '7年级以下',
    ]
    sourceChildList: any[] = []
    wechat = '' // 学生微信ID
    phone = '' // 手机号
    other = '' // 其他联系方式
    remark = '' // 备注
    identity = '' // 身份
    region = '' // 地域
    regionName = '' // 当地域选择为【其他】的时候 使用
    equipment = '' // 设备
    keyword = '' // 关键字
    filterWord = '' // 搜索词
    consultingPage = '' // 咨询页面
    direction = '' // 咨询专业方向 --- 下拉
    directionInput = '' // 咨询专业方向 --- 输入框
    directionList = ['理工科', '传媒艺术电影', '人文社科', '金融商科', '计算机', '其他']
    eduTemandOptions = ['留学', '高考', '考研', '保研', '考博', '无升学需求','待定']
    // eduTemandValue: string[] = [] // 升学需求

    degree = '' // 意向度
    status = 1 // 是否下发
    degreeList = ['高', '中', '低']
    time = new Date() // 创建时间
    directorUserId = '' // 负责人ID
    repeatDetailShow = false //  重复的数据
    repeatDetailTable = [] // 重复弹框是否显示
    repeatName = false // 名字重复
    repeatWechat = false // 微信号重复
    repeatPhone = false // 手机号重复
    newBtnDisabled = false
    marketClueId = 0
    createName = ''
    elCascaderInput = false
    editMaketClueStatus = ''

    cascaderProps = {
        value: 'id',
        label: 'name',
        expandTrigger: 'click',
        lazy: true,
        lazyLoad: this.cascaderLazyload
    }
    // saveBtn = true
    marketLevelPage = 1
    marketLevelSize = 20
    // marketLevelTotal = 0
    cooperativePartnerName = ''
    marketLevelloading = false
    sourceNameId = null
    repeatDetailTable1 = []
    repeatDetailTable2 = []
    repeatDetailTable3 = []
    formRules = {
        clueName: [{ required: true, message: '请填写线索名称', trigger: 'blur' }],
        sourceType: [{ required: true, message: '请选择来源', trigger: 'change' }],
        sourceName: [{ required: true, message: '请选择具体来源名称', trigger: 'blur' }],
        receiverUserId: [{ required: true, message: '请选择下发对接人', trigger: 'change' }],
        grade: [{ required: true, message: '请选择学生年级', trigger: 'change' }],
        eduTemandValue: [{ required: true, message: '请选择升学需求', trigger: 'change' }],
        isQuote: [{ required: true, message: '请选择是否报价', trigger: 'change' }],
        // attendSchool: [{ required: true, message: '请选择就读学校', trigger: ['change','blur'] }], 2024-3-5改成非必填
    }
    formModel = {
        clueName: '', // 线索名称
        sourceType: '', // 来源
        sourceName: '', // 集体来源名称id
        receiverUserId: '', // 下发人ID
        grade : '', // 学生年级
        eduTemandValue : [], // 升学需求
        isQuote : '', // 是否报价
        attendSchool: '' ,// 就读学校
        schoolId: null // 就读学校id
    }
    sourceIdList: any = [] // 具体来源名称
    addDialog = false  //添加学校
    name = ''
    page = 1
    schoolList = []
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    pageSchool = 1

    // ------ 计算属性 ------
    get UserName() {
        return this.marketClueId === 0 ? UserModule.userName : this.createName
    }

    get userId() {
        return UserModule.userId
    }

    get userList() {
        return UserModule.userList
    }


    // ------ 生命周期 ------
    created() {
        if (this.$route.query.id) {
            this.marketClueId = Number(this.$route.query.id)
            this.editMaketClueStatus = this.$route.query.status as string
            this.getMarketClueById()
            this.elCascaderInput = true
        }
    }

    // ------ 方法 -------
    async getMarketClueById() {
        const data: any = await getMarketClueById({ id: this.marketClueId })
        const { createUserRealName, createdAt, degree, direction, directorUserId, grade,isQuote, name, other, phone, receiverUserId, remark, source, sourceType, status, wechat, marketChannelId, eduTemandList, consultPage, equipment, identity, keyWord, region, searchWord,marketLevel1ChannelId,schoolId, attendSchool } = data.marketClue
        this.formModel.schoolId = schoolId;
        this.formModel.attendSchool = attendSchool == null ? '' : attendSchool;
        this.createName = createUserRealName == null ? '' : createUserRealName
        this.time = createdAt == null ? '' : createdAt
        this.degree = degree == null ? '' : degree
        this.directorUserId = directorUserId == null ? '' : directorUserId
        this.formModel.grade = grade == null ? '' : grade
        this.formModel.isQuote = isQuote == null ? '' : isQuote
        // this.formModel.clueName = name == null ? '' : name
        this.formModel.clueName = name == null ? '' : name
        this.other = other == null ? '' : other
        this.phone = phone == null ? '' : phone
        // this.receiverUserId = receiverUserId == null ? '' : receiverUserId
        this.formModel.receiverUserId = receiverUserId == null ? '' : receiverUserId
        this.remark = remark == null ? '' : remark
        // this.sourceName = source == null ? '' : source
        this.formModel.sourceName = source == null ? '' : source
        // this.sourceType = sourceType == null ? '' : String(sourceType)
        this.formModel.sourceType = sourceType == null ? '' : String(sourceType)
        this.sourceId = marketChannelId == null ? '' : marketChannelId;
        (this.status as any) = status === '是' ? 1 : 0
        this.wechat = wechat == null ? '' : wechat
        this.formModel.eduTemandValue = eduTemandList.length > 0 ? eduTemandList : []
        if (this.directionList.indexOf(direction) != -1) {
            this.direction = direction
        } else {
            this.direction = '其他'
            this.directionInput = direction == null ? '' : direction
        }
        this.identity = identity
        this.keyword = keyWord
        this.filterWord = searchWord
        this.region = region
        this.equipment = equipment
        this.consultingPage = consultPage
        if (this.formModel.sourceType === '1') {
            const data1: any = await getMarketChannelType()
            this.sourceChildList = data1.marketChannelTypeList
        }
        if (this.formModel.sourceType === '0') {
            this.getMarketCooperationPrevLevel()
        }
       //    add 高校/分管
        if (this.formModel.sourceType === '3') {
            const data: any = await getMarketHighSchoolBranchCenterList('3')
            this.collegesList = data.marketHighSchoolBranchCenterList
        }
        if (this.formModel.sourceType === '4') {
            const data: any = await getMarketHighSchoolBranchCenterList('4')
            this.branchedPassageList = data.marketHighSchoolBranchCenterList
        }
        this.sourceIdList=[marketLevel1ChannelId]
    }
    async sourceChange() {

        // if (this.sourceType === '1') {
        if (this.formModel.sourceType === '1') {
            const data: any = await getMarketChannelType()
            this.sourceChildList = data.marketChannelTypeList
            // this.sourceName = ''
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '0') {
            this.getMarketCooperationPrevLevel()
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '2') {
            this.formModel.sourceName = ''
        }
        //    add 高校/分管
        if (this.formModel.sourceType === '3') {
            const data: any = await getMarketHighSchoolBranchCenterList('3')
            this.collegesList = data.marketHighSchoolBranchCenterList
            this.formModel.sourceName = ''
        }
        if (this.formModel.sourceType === '4') {
            const data: any = await getMarketHighSchoolBranchCenterList('4')
            this.branchedPassageList = data.marketHighSchoolBranchCenterList
            this.formModel.sourceName = ''
        }

    }

    async confirmSchool() {
        await setSchool({name: this.schoolName, types: this.schoolType})
        this.$message.success('新建学校成功')
        this.formModel.attendSchool = this.schoolName
        const result: any = await getSchoolList({page: this.pageSchool,  name: this.schoolName })
        const schoolItem = result.schoolList.filter(item => item.name === this.schoolName)[0]
        this.formModel.schoolId = schoolItem.id
        this.schoolList = result.schoolList
        this.schoolName = ''
        this.schoolType = ''
        this.addDialog = false
    }

    async getSchoolList() {
        const data: any = await getSchoolList({page: this.page,  name: this.name})
        this.schoolList = [...this.schoolList, ...data.schoolList]
        const result = []
        const obj = {}
        for(let i =0; i<this.schoolList.length; i++){
            if(!obj[this.schoolList[i].id]){
                result.push(this.schoolList[i]);
                obj[this.schoolList[i].id] = true;
            }
        }
        this.schoolList = result
    }
    loadmore() {
        this.page++
        this.getSchoolList();
    }
    async remoteMethod (query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getSchoolList({page: this.page,  name: query })
            this.schoolList = result.schoolList
        } else {
            //   this.schoolList = []
        }
    }
    async handleSchool(){
        if((this.schoolList.length == 0 || !this.name) && !this.formModel.attendSchool){
            this.name = null
            this.page = 1
            const result: any = await getSchoolList({page: this.page,  name: this.name })
            this.schoolList = result.schoolList
        }
        if(this.formModel.attendSchool){
            this.schoolList = []
            this.page = 1
            // const result: any = await getSchoolList({page: this.page,  name: this.name })
            const result: any = await getSchoolList({page: this.page,  name: this.formModel.attendSchool })
            this.schoolList = result.schoolList
        }
    }
    // 选择学校
    changeSchool (val) {
        if(val) {
            this.formModel.attendSchool = val
            this.formModel.schoolId = this.schoolList.find(item=> item.name === this.formModel.attendSchool).id
        }
    }
    clearSchool() {
        this.formModel.schoolId = null
        this.formModel.attendSchool = ''
        this.name = null
        this.page = 1
        this.getSchoolList()
    }

    async cascaderLazyload(node: any, reslove: any) {
        this.sourceIdList = [node.value]
        this.sourceId = node.value
        this.formModel.sourceName = node.label
        if (node.level === 0) { reslove(); return }
        const data: any = await getMarketChannelNameByTypeId(node.value)
        let nodes: any[] = []
        nodes = data.marketChanneNamelList.map((item: any) => ({
            id: item.id,
            name: item.name,
            leaf: node.level >= 1
        }))
        reslove(nodes)
    }

    async newClue() {
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if (this.status == 1 && !this.formModel.receiverUserId) {
                //     this.$message.error('请选择下发对接人');
                //     return
                // }
                if (this.wechat === '' && this.phone === '' && this.other === '') {
                    this.$message.error('请将学生微信，手机号，其他联系方式中任一填写完整');
                    return
                }
                this.newBtnDisabled = true
                const obj = {
                    name: this.formModel.clueName,
                    sourceType: Number(this.formModel.sourceType),
                    source: this.formModel.sourceName,
                    wechat: this.wechat,
                    phone: this.phone,
                    other: this.other,
                    grade: this.formModel.grade,
                    isQuote: this.formModel.isQuote,
                    direction: this.direction == '其他' ? this.directionInput : this.direction,
                    remark: this.remark,
                    degree: this.degree,
                    directorUserId: this.directorUserId,
                    status: this.status,
                    receiverUserId: this.formModel.receiverUserId,
                    marketChannelId: this.sourceId,
                    eduTemandList: this.formModel.eduTemandValue,
                    identity: this.identity,
                    region: this.region === '其他' ? this.regionName : this.region,
                    equipment: this.equipment,
                    keyWord: this.keyword,
                    searchWord: this.filterWord,
                    consultPage: this.consultingPage,
                    attendSchool: this.formModel.attendSchool,
                    schoolId: this.formModel.schoolId,
                }
                if (this.formModel.sourceType !== '1') {
                    delete obj.marketChannelId
                }
                // const arr = ['identity', 'region', 'equipment', 'keyWord', 'searchWord', 'consultPage']
                // arr.forEach(item => {
                //     if (!obj[item] || item.length === 0) delete obj[item]
                // })
                setMarketClue(delNullProperty(obj)).then(() => {
                    this.$message.success('新建线索成功，页面即将关闭')
                    setTimeout(() => {
                        window.close()
                    }, 2000)
                }).catch(() => {
                    this.newBtnDisabled = false
                })



            }
        })

    }
    handleRepeatDetail(type){
        this.repeatDetailShow = true
        if(type == '0'){
            this.repeatDetailTable = this.repeatDetailTable1
        }
        if(type == '1'){
            this.repeatDetailTable = this.repeatDetailTable2
        }
        if(type == '2'){
            this.repeatDetailTable = this.repeatDetailTable3
        }
    }s
    async duplicateCheck(types: number) {
        const obj: any = {
            types,
            values: '',
            // id: this.marketClueId === 0 ? '' : this.marketClueId
        }

        if (this.marketClueId !== 0) {
            obj['id'] = this.marketClueId
        }
        switch (types) {
            case 0:
                if (!this.formModel.clueName) return
                obj.values = this.formModel.clueName
                const data1: any = await duplicateCheck(obj)
                if (data1.result.length > 0) {
                    this.repeatDetailTable1 = data1.result
                    this.repeatName = true
                } else {
                    this.repeatName = false
                }
                break;
            case 1:
                if (!this.wechat) return
                obj.values = this.wechat
                const data2: any = await duplicateCheck(obj)
                if (data2.result.length > 0) {
                    this.repeatDetailTable2 = data2.result
                    this.repeatWechat = true
                } else {
                    this.repeatWechat = false
                }
                break;
            case 2:
                if (!this.phone) return
                obj.values = this.phone
                const data3: any = await duplicateCheck(obj)
                if (data3.result.length > 0) {
                    this.repeatDetailTable3 = data3.result
                    this.repeatPhone = true
                } else {
                    this.repeatPhone = false
                }
                break;
        }
        const data: any = await duplicateCheck(obj)
        // if(data.result.length > 0){
        //     this.saveBtn = false
        // }else if(data.result.length == 0){
        //     this.saveBtn = true
        // }

        if (data.result.length > 0) {
            this.repeatDetailTable = data.result
            return true
        } else {
            return false
        }
    }

    async setMarketClueById() {
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if (this.status == 1 && !this.formModel.receiverUserId) {
                //     this.$message.error('请选择下发对接人');
                //     return
                // }
                if (this.wechat === '' && this.phone === '' && this.other === '') {
                    this.$message.error('请将学生微信，手机号，其他联系方式中任一填写完整');
                    return
                }
                const obj = {
                    name: this.formModel.clueName,
                    sourceType: Number(this.formModel.sourceType),
                    source: this.formModel.sourceName,
                    wechat: this.wechat,
                    phone: this.phone,
                    other: this.other,
                    grade: this.formModel.grade,
                    isQuote: this.formModel.isQuote,
                    direction: this.direction == '其他' ? this.directionInput : this.direction,
                    remark: this.remark,
                    degree: this.degree,
                    directorUserId: this.directorUserId,
                    status: this.status,
                    receiverUserId: this.formModel.receiverUserId,
                    schoolId: this.formModel.schoolId,
                    attendSchool: this.formModel.attendSchool,
                    id: this.marketClueId,
                    marketChannelId: this.sourceId,
                    eduTemandList: this.formModel.eduTemandValue,
                    identity: this.identity,
                    region: this.region === '其他' ? this.regionName : this.region,
                    equipment: this.equipment,
                    keyWord: this.keyword,
                    searchWord: this.filterWord,
                    consultPage: this.consultingPage
                }
                if (this.formModel.sourceType !== '1') {
                    delete obj.marketChannelId
                }
                this.newBtnDisabled = true
                // if(!this.saveBtn){
                //     this.$message.error('存在重复，无法保存')
                //     this.newBtnDisabled = false
                //     return
                // }
                setMarketClueById(obj).then(res => {
                    this.$message.success('编辑线索成功')
                    setTimeout(() => {
                        this.clickClose()
                    }, 1500)
                }).catch(() => this.newBtnDisabled = false)
            }
        })
    }

    seeClue(row: any) {
        if(row.types ==='线索'){
            window.open(window.location.origin + this.$route.matched[0].path + '/marketSeeClue?id=' + row.id, '_blank')
        }else if(row.types ==='客户'){ // 客户
            window.open(window.location.origin + '/customer' + '/transfromCustomerEdit?id=' + row.id, '_blank')
        }
    }

    changeSourceName(val?: any) {
        const node = (this.$refs['cascader'] as HTMLFormElement).getCheckedNodes()[0]
        this.sourceId = node.value
        this.formModel.sourceName = node.label
    }

    clickClose() {
        window.close()
    }

    // 修改下发状态
    changeStatus(value: number) {
        if (value === 0) {
            this.formModel.receiverUserId = ''
        }
    }

    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(
            {
                page: this.marketLevelPage,
                name: this.cooperativePartnerName,
                limit: this.marketLevelSize
            }
        )
        this.cooperativePartnerList = [...this.cooperativePartnerList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.cooperativePartnerList.length; i++) {
            if (!obj[this.cooperativePartnerList[i].id]) {
                result.push(this.cooperativePartnerList[i]);
                obj[this.cooperativePartnerList[i].id] = true;
            }
        }
        this.cooperativePartnerList = result
    }

    // async handleCooperativePartner() {
    //     if ((this.cooperativePartnerList.length == 0 || !this.cooperativePartnerName) && !this.sourceName) {
    //         this.cooperativePartnerName = null
    //         this.marketLevelPage = 1
    //         this.marketLevelSize = 20
    //         const result: any = await getMarketCooperationPrevLevel({
    //             page: this.marketLevelPage,
    //             limit:this.marketLevelSize,
    //             name: this.cooperativePartnerName
    //         })
    //         this.cooperativePartnerList = result.marketCooperationList
    //     }
    //     if (this.sourceName) {
    //         this.cooperativePartnerList = []
    //         this.marketLevelPage = 1
    //         this.marketLevelSize = 20
    //         const result: any = await getMarketCooperationPrevLevel({
    //             page: this.marketLevelPage,
    //             limit:this.marketLevelSize,
    //             name: this.sourceName,
    //         })
    //         this.cooperativePartnerList = result.marketCooperationList
    //     }
    // }
    //
    // handleCooperativePartnerBlur() {
    //     if (!this.sourceNameId) {
    //         this.cooperativePartnerName = null
    //         this.marketLevelPage = null
    //         this.marketLevelSize = null
    //         this.getMarketCooperationPrevLevel()
    //     }
    // }

    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel({
                page: this.marketLevelPage,
                limit:this.marketLevelSize,
                name: query
            })
            this.cooperativePartnerList = result.marketCooperationList
        }
    }

    changeCooperativePartner(val) {
        this.formModel.sourceName = val
        this.sourceNameId = this.cooperativePartnerList.find(item => item.name === val).id
    }

    clearCooperativePartner() {
        this.cooperativePartnerList= []
        this.sourceNameId = null
        this.formModel.sourceName = ''
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }

    @Watch('userId')
    userIdChange() {
        this.directorUserId = this.userId
    }
}
